<template>
  <div>
    <a
      href="https://www.zyxel.com"
      target="_blank"
    ><img
      class="w-[90px] h-10 mt-5 sm:ml-8 mb-5"
      src="@/assets/svg/logo_Zyxel networks.svg"
      alt="Zyxel Networks"
    ></a>
  </div>
</template>

<script>
export default {
    name: 'LogoIcon'
}
</script>
